import { render } from "./subcategory.vue?vue&type=template&id=79ad38c4"
import script from "./subcategory.vue?vue&type=script&lang=js"
export * from "./subcategory.vue?vue&type=script&lang=js"

import "./subcategory.vue?vue&type=style&index=0&id=79ad38c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__